function TicketCreateModule() { }

TicketCreateModule.Extend(Module);

TicketCreateModule.prototype.settings = {

};

TicketCreateModule.prototype.elementMap = {
	"priorityDropdown" : "div.priority > button",
	"priorityData" : "input.priorityData",
	"notifiedData" : "input.notifiedData"
};

TicketCreateModule.prototype.initModule = function () {
	this.attachedFiles = [];
	this.queuedFiles = 0;
	this.notifiedList = [];
	this.userName = $("#SiteHeaderModule span.userName").text();
	this.initUpload();

	this.$el("input.required,textarea.required").on("blur",$.proxy(this.textBlur,this));
	this.$el("input[placeholder],textarea[placeholder]",true).placeholder();
};

TicketCreateModule.prototype.initUpload = function () {

	var uploader = new plupload.Uploader({
		runtimes : 'html5,flash,silverlight,browserplus,html4',
		browse_button : 'pickfiles',
		container : 'uploadContainer',
		max_file_size : '15mb',
		url : '~/Ticket/Upload'.resolveUrl(),
		flash_swf_url : '~/content/scripts/common/plupload/plupload.flash.swf'.resolveUrl(),
		silverlight_xap_url : '~/content/scripts/common/plupload/js/plupload.silverlight.xap'.resolveUrl(),
		filters : [
			{title : "Image files", extensions : "jpg,gif,png,bmp"},
			{title : "Document files", extensions : "csv,txt,pdf,doc,docx,xls,xlsx,ppt,pptx,htm,xml"},
			{title : "Video files", extensions : "avi,mp4,flv,mov,wmv"},
			{title : "Zip files", extensions : "zip"}
		]
	});


	uploader.bind('Init', function(up, params) {
		//$('#filelist').html("<div>Current runtime: " + params.runtime + "</div>");
	});

	$('#uploadfiles').click(function(e) {
		uploader.start();
		e.preventDefault();
	});

	uploader.init();

	uploader.bind('FilesAdded', $.proxy(function(up, files) {
		$.each(files, function(i, file) {
			$('#filelist').append(
				'<tr id="' + file.id + '">' +
				'<td class="fileName">' + file.name + ' (' + plupload.formatSize(file.size) + ')</td><td class="pContainer"><div class="progress"></div></td>' +
			'</tr>');
		});
		this.queuedFiles += files.length;
		var $button = this.$el("button.createTicket",true);
		if(!$button.hasClass("disabled")) {
			$button.addClass("disabled");
		}
		up.refresh(); // Reposition Flash/Silverlight
		up.start();
	},this));

	uploader.bind('UploadProgress', function(up, file) {
		$('#' + file.id + " div.progress").css('width', file.percent + '%');
	});

	uploader.bind('Error', function(up, err) {
		/*$('#filelist').append("<div>Error: " + err.code +
			", Message: " + err.message +
			(err.file ? ", File: " + err.file.name : "") +
			"</div>"
		);*/
		if(err) {
			if(err.file) {
				$('#' + err.file.id + ' div.progress').css('background-color', 'red');
			}
			if(err.code && err.code == -600) {
				alert("The file you attempted to upload is too large. The maximum attachment size is 15MB.");
			}
		}

		up.refresh(); // Reposition Flash/Silverlight
	});

	uploader.bind('FileUploaded', $.proxy(function(up, file, info) {
		$('#' + file.id + " b").html("100%");
		if(info.response) {
			var json = info.response.split('\n')[0];
			var data = $.parseJSON(json);

			data["submittername"] = this.userName;

			this.attachedFiles.push(data);

			if(this.queuedFiles == this.attachedFiles.length) {
				var $button = this.$el("button.createTicket",true);
				if($button.hasClass("disabled")) {
					$button.removeClass("disabled");
				}
			}
		}
		
	},this));
			
};

TicketCreateModule.prototype.textBlur = function(e) {
	var $el = $(e.target);
	var val = $el.val();
	if(val && val.trim()) {
		$el.removeClass("invalid");
	}
	else {
		$el.addClass("invalid");
	}
	this.validate();
};

TicketCreateModule.prototype.validate = function() {
	if(this.$el(".invalid",true).length == 0) {
		this.$el("button.createTicket").removeClass("disabled");
	}
};

TicketCreateModule.prototype.action_processTicketCreate = function ($el, val) {

	if($el.hasClass("disabled")) {
		return;
	}
	this.showLoading();
	this.ajax({
		url: '~/Ticket/Create',
		data: this.getFormData(),
		success: $.proxy(this.ticketCreated,this)
	});
};

TicketCreateModule.prototype.action_updatePriority = function($el,val) {
	var selection = $el.find("div.listLbl").text();
	this.$el("priorityDropdown").find("span.selectedVal").text(selection).addClass("active");
	this.$el("priorityDropdown").dropdown("toggle").removeClass("invalid");

	this.$el("priorityData").val(selection);	

	this.validate();
};

TicketCreateModule.prototype.action_notifyToggle = function($el, val) {
	$(".bluecheck",$el).toggleClass("none");

	if($.inArray(val,this.notifiedList) == -1) {
		this.notifiedList.push(val);
	}
	else {
		Util.removeFromArray(this.notifiedList, val);
	}
	this.$el("notifiedData",true).val(this.notifiedList.join(","));
};

TicketCreateModule.prototype.ticketCreated = function(data) {
	this.hideLoading();
	this.closeModal();
	Module.fireModuleMethod("TicketSearchModule", "reload");
	Module.fireModuleMethod("ActivityFeedModule", "reload");
};

TicketCreateModule.prototype.getFormData = function() {
	var data = {};

	var $inputs = this.$el("input,textarea");

	for(var i = 0; i < $inputs.length; i++) {
		var $element = $($inputs[i]);
		var name = $element.attr("name");
		data[name] = encodeURIComponent($element.val());
	}

	data['uploadedFiles'] = JSON.stringify(this.attachedFiles);

	return data;
};